import React, { FC, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { useAtomValue } from 'jotai/utils';

import { modalDataAtom } from 'atoms/modal';
import { snackbarProgressAtom } from 'atoms/snackbars/snackbars.atom';

import AccountRoute from 'routes/AccountRoute';

import { useShortcutListener } from 'hooks/shortcutManager/shortcutListener';
import { useDebugger } from 'hooks/useDebugger';

import Modal from 'common/Modal/Modal';
import SnackbarsStackViewer from 'common/SnackbarsStackViewer/SnackbarsStackViewer';
import SnackbarsWrapper from 'common/SnackbarsWrapper/SnackbarsWrapper';

import PageNotFound from '_manager/PageNotFound/PageNotFound';

import { ProtectedRoute } from './routes/ProtectedRoute/protectedRoute';

const Manager = React.lazy(() => import('_manager/Manager/Manager'));
const NewProjectForm = React.lazy(
  () => import('_manager/_forms/NewProjectForm/NewProjectForm')
);
const Editor = React.lazy(() => import('_editor/Editor/Editor'));
const ViewPublishedProject = React.lazy(
  () => import('./components/_published-project/ViewPublishedProject')
);

const Debugger = () => {
  useDebugger();

  return null;
};

const App: FC = () => {
  const modalData = useAtomValue(modalDataAtom);
  const progressSnackbars = useAtomValue(snackbarProgressAtom);

  useShortcutListener();

  return (
    <Suspense fallback="">
      {/* <StrictMode> */}
      {/* Shown only on development enviroment */}
      {/* {process.env.NODE_ENV !== 'production' && <Debugger />} */}
      <Router>
        {modalData?.isOpen && <Modal />}
        <SnackbarsWrapper />
        {!!progressSnackbars.length && <SnackbarsStackViewer />}
        <Switch>
          <ProtectedRoute exact path="/">
            <Redirect to="/manager" />
          </ProtectedRoute>
          <Route path="/account">
            <AccountRoute />
          </Route>
          <ProtectedRoute exact path="/manager/new">
            <NewProjectForm />
          </ProtectedRoute>
          <ProtectedRoute path="/manager">
            <Manager />
          </ProtectedRoute>
          <Route path="/view/:id">
            <ViewPublishedProject />
          </Route>
          <Route path="/view">
            <PageNotFound />
          </Route>
          <ProtectedRoute exact path="/:id">
            <Editor />
          </ProtectedRoute>
          <Route path="*">
            <PageNotFound />
          </Route>
        </Switch>
      </Router>
      {/* </StrictMode> */}
    </Suspense>
  );
};

export default App;
